import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints, fontWeights, fontSizes, palette, siteMediumWidth, spaceMin,
}: Theme) => ({
  root: {
    position: 'relative',
    width: '100%',
    maxWidth: siteMediumWidth,
    margin: '0 auto',
    border: `1px solid ${palette.grey['400']}`,
    borderRadius: '0.5rem',
    overflow: 'hidden',
    background: palette.common.white,
    [breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    textDecoration: 'none',
    [breakpoints.up('md')]: {
      flexDirection: 'row',
    },
    [breakpoints.up('xl')]: {
      alignItems: 'center',
    },
    '&:focus-visible': {
      outline: `1px dashed ${palette.primary.dark}`,
      outlineOffset: 2,
    },
  },
  sectionTitle: {
    width: '100%',
    margin: 0,
    color: palette.text.primary,
    fontWeight: fontWeights.medium,
    fontSize: '1.25rem',
    lineHeight: 1.4,
    // Temp solution, delete after font is updated
    letterSpacing: '-0.02em',
    [breakpoints.up('md')]: {
      fontSize: fontSizes.xxl,
      lineHeight: 1.3,
    },
    '& sup': {
      fontSize: '60%',
    },
  },
  content: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: spaceMin,
    width: '100%',
    padding: spaceMin,
    [breakpoints.up('md')]: {
      width: '50%',
      height: 'fit-content',
    },
  },
  imgContainer: {
    width: '100%',
    [breakpoints.up('md')]: {
      width: '50%',
    },
    '& img': {
      display: 'block',
      width: '100%',
      objectFit: 'contain',
      height: 'auto',
    },
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
}));
